import { z } from 'zod'

export const formSchema = z.object({
  date: z.string(),
  studentName: z.string(),
  oen: z.string(),
  grade: z.string(),
  gradeInSeptember: z.string(),
  teacher: z.string(),
  board: z.string(),
  school: z.string(),
  address1: z.string(),
  address2: z.string(),
  principal: z.string(),
  telephone: z.string(),
  daysAbsent: z.string(),
  totalDaysAbsent: z.string(),
  timesLate: z.string(),
  totalTimesLate: z.string(),
  responsibility1: z.string(),
  organization1: z.string(),
  independentWork1: z.string(),
  collaboration1: z.string(),
  initiative1: z.string(),
  selfRegulation1: z.string(),
  responsibility2: z.string(),
  organization2: z.string(),
  independentWork2: z.string(),
  collaboration2: z.string(),
  initiative2: z.string(),
  selfRegulation2: z.string(),
  strengthsNextStepsLSWH: z.string(),
  languagePlan: z.string(),
  languageGrade1: z.string(),
  languageGrade2: z.string(),
  languageComments: z.string(),
  nativeLanguage: z.string(),
  nativeLanguagePlan: z.string(),
  nativeLanguageGrade1: z.string(),
  nativeLanguageGrade2: z.string(),
  nativeLanguageComments: z.string(),
  frenchPlan: z.string(),
  frenchListeningPlan: z.string(),
  frenchListeningGrade1: z.string(),
  frenchListeningGrade2: z.string(),
  frenchSpeakingPlan: z.string(),
  frenchSpeakingGrade1: z.string(),
  frenchSpeakingGrade2: z.string(),
  frenchReadingPlan: z.string(),
  frenchReadingGrade1: z.string(),
  frenchReadingGrade2: z.string(),
  frenchWritingPlan: z.string(),
  frenchWritingGrade1: z.string(),
  frenchWritingGrade2: z.string(),
  frenchComments: z.string(),
  mathematicsPlan: z.string(),
  mathematicsGrade1: z.string(),
  mathematicsGrade2: z.string(),
  mathematicsComments: z.string(),
  scienceAndTechnologyPlan: z.string(),
  scienceAndTechnologyGrade1: z.string(),
  scienceAndTechnologyGrade2: z.string(),
  scienceAndTechnologyComments: z.string(),
  socialStudiesPlan: z.string(),
  socialStudiesGrade1: z.string(),
  socialStudiesGrade2: z.string(),
  socialStudiesComments: z.string(),
  healthEducationPlan: z.string(),
  healthEducationGrade1: z.string(),
  healthEducationGrade2: z.string(),
  physicalEducationPlan: z.string(),
  physicalEducationGrade1: z.string(),
  physicalEducationGrade2: z.string(),
  healthAndPhysicalEducationComments: z.string(),
  artsHeader: z.string(),
  arts1: z.string(),
  arts1Plan: z.string(),
  arts1Grade1: z.string(),
  arts1Grade2: z.string(),
  arts2: z.string(),
  arts2Plan: z.string(),
  arts2Grade1: z.string(),
  arts2Grade2: z.string(),
  arts3: z.string(),
  arts3Plan: z.string(),
  arts3Grade1: z.string(),
  arts3Grade2: z.string(),
  arts4: z.string(),
  arts4Plan: z.string(),
  arts4Grade1: z.string(),
  arts4Grade2: z.string(),
  artsComments: z.string(),
  optionalStudies: z.string(),
  optionalStudiesPlan: z.string(),
  optionalStudiesGrade1: z.string(),
  optionalStudiesGrade2: z.string(),
  optionalStudiesComments: z.string(),
  ersCompleted: z.string(),
  ersDateYear: z.string(),
  ersDateMonth: z.string(),
  ersDateDay: z.string(),
  ersBenchmark: z.string(),
  _completedFields: z.array(z.string()).default([]),
})

export const defaultValues = {
  ...Object.fromEntries(
    Object.keys(formSchema.shape)
      .filter((k) => k !== '_completedFields')
      .map((k) => [k, ''])
  ),
  _completedFields: [],
}
